import React, { ReactElement, ComponentPropsWithRef } from 'react';
import classnames from 'classnames';
import { FormGroup, FormGroupText } from '../FormGroup';

export type TextareaProps = ComponentPropsWithRef<'textarea'> & {
  error?: string;
  horizontal?: boolean;
  label?: string;
  labelClass?: string;
  required?: boolean;
};

export function Textarea({
  error,
  horizontal = true,
  id,
  label,
  labelClass,
  required,
  ...rest
}: TextareaProps): ReactElement {
  const classes = classnames({ error });

  return (
    <FormGroup horizontal={horizontal} errors={error ? [error] : []}>
      <FormGroupText>
        <label className={labelClass} htmlFor={id}>
          {label} {required && '*'}
        </label>
        <textarea id={id} className={classes} {...rest} />
      </FormGroupText>
    </FormGroup>
  );
}
